import { ReactNode } from 'react';

interface AvatarProps {
  children: ReactNode;
}

export function Avatar({ children }: AvatarProps) {
  return (
    <div
      className="
        bg-bg-layout-subtle-default
        color-gray-1000
        p-layout-xs
        rounded-full
      "
    >
      {children}
    </div>
  );
}
